<template>
	<div class="ReReportForm">

        <h6 class="mb-1">Формирование отчета</h6>	
        <div :class="getTopClass">
            <div class="mr-2">
                <el-select						
                    class="col-md px-0 select-primary overflow-overlay "	
                    style="height:auto; width: fit-content; max-width: 300px; margin-top:5px;"					
                    filterable
                    placeholder="Выберите тип отчёта"
                    size="large"
                    v-model="reportAttributes" 
                >
                    <el-option
                        class="select-primary long-select"
                        v-for="report in allReports"
                        :key="report.obj"
                        :label="report.name"
                        :value="report.obj"
                    >
                    </el-option>
                </el-select>
            </div>
            <slot></slot>
            <div class="d-flex align-items-center flex-wrap">
                <base-button   
                @click="formReport(reportAttributes)" 
                class="btn-simple btn-success mr-2"
                :disabled="noFilter"
                >Сформировать отчет</base-button>	

                <base-button   
                @click="clearReportTable()" 
                
                class="btn-simple btn-danger mr-2" 
                >Очистить</base-button>

                <base-button
                v-if="download"
                @click="reportDownload(reportAttributes)" 
                class="btn-simple btn-success mr-2" 
                :disabled="noFilter"
                >Скачать <i class="fa fa-file-excel ml-1"></i></base-button>	

                <base-button
                v-if="download_pdf"
                @click="reportDownload(reportAttributes,'pdf_file')" 
                class="btn-simple btn-success mr-2" 
                :disabled="noFilter"
                >Скачать PDF<i class="fa fa-file-pdf ml-1"></i></base-button>	

                <base-button
                v-if="download_html"
                @click="reportDownload(reportAttributes,'html_file')" 
                class="btn-simple btn-success my-0" 
                :disabled="noFilter"
                >Печать<i class="fa fa-file ml-1"></i></base-button>	
            </div>
            
        </div>
        <template v-if="this.reportAttributes != '' && !this.$GVO.isEmpty(this.objReport)">
            <ReReports :module="obj" :flt="objGetParams" :keyParam="reportAttributes" :tags="this.massTags" :strTags="this.strTags" :objReport="objReport" />
        </template>
    </div>
</template>
<script>
    import ReReports from 'src/our_components/ReReports.vue';
    import {  Select, Option, Button } from 'element-ui';
    import {eventEmitter} from "src/plugins/globalComponents.js";

	export default {
		name: 'ReReportForm',
        components: {
            ReReports,
            [Option.name]: Option,
            [Select.name]: Select,
            [Button.name]: Button,
        },
		props: {
            obj: String,
            strTags: String,
            massTags: Array,
            isFilterDirty: {
				type: Boolean,
				default: false
			},
            download: {
				type: Boolean,
				default: true
			},
            download_pdf: {
				type: Boolean,
				default: false
			},
            download_html: {
				type: Boolean,
				default: false
			},

        },
        data(){
            return {
                allReports: [],
                objReport: {},
                reportAttributes: '',
            }
        },
        watch: {
            isFilterDirty(val){
                if(val == true){
                    this.clearReportTable();
                }
            },
            reportAttributes(value){
                const foundReport = this.allReports.find(report => report.obj === value);
                if (foundReport) {
                    this.$emit('filterFields',foundReport.filters||[])
                }                
            },
        },
        computed:{
            getTopClass(){
                return this.inFilters? [] : ['d-flex','align-items-center','flex-wrap'];
            },
            inFilters(){
                return !!this.$slots.default;
            },
            noFilter(){
                return this.reportAttributes=='' || this.isFilterDirty;
            }
        },
        methods:{
            getAllReports(){
                this.allReports = [];
                
                this.$GVO.ApiCall('GET_REPORTS',{obj:this.obj ,flt:{} })
                .then((objApi) => { 
                    if(objApi.success === true){ //console.log(objApi);
                        this.allReports = objApi.data;
                    }else{
                        this.allReports = [];
                    }
                }).catch((errorObjApi) => {console.error(errorObjApi); this.allReports = [];});
            },
            filter(){
                eventEmitter.$emit('RemoteApplyFilter', true);
                this.objGetParams = this.$GVO.GetAllGet();
                let filter = {};
                if (!this.$GVO.isEmpty(this.objGetParams)) {
                    filter = this.$GVO.SafeParseJson(JSON.stringify(this.objGetParams));
                }
                return filter;
            },
            getReportObj(){
                return {obj:this.obj, flt:{...this.filter()}, tags: this.strTags };
            },
            formReport(report){
              
                this.$GVO.ApiCall(report, this.getReportObj())
                .then((objApi) => { 
                    this.objReport = {};
                    if(objApi.success === true){
                        // console.log(objApi);
                        this.objReport = objApi;
                        if(typeof objApi.file_path != 'undefined' && objApi.file_path != ''){
                            window.open(this.$GVO.endpoint_domen+objApi.file_path, '_blank');
                        }
                    }else{
                        this.objReport = {};
                    }
                }).catch((errorObjApi) => {console.error(errorObjApi); this.objReport = {};});
                //console.log();
            },
            reportDownload(report,type='file'){
                const data = this.getReportObj();
                data.method = report;

                this.$GVO.ApiCall(type,{obj:'reports', data})
                .then((objApi) => { 
                    if(objApi.success === true){ 
                        // console.log(objApi);
                        if(typeof objApi.file_path != 'undefined' && objApi.file_path != ''){
                            window.open(this.$GVO.endpoint_domen+objApi.file_path, '_blank');
                        }
                    }else{
                        // Выдать ошибку?
                    }
                }).catch((errorObjApi) => {console.error(errorObjApi); });
            },
            clearReportTable(){
                this.objReport = {};
                // нельзя это сбрасывать. но мы должны получить из родительского компонента событие что фильтры были применены
                // this.reportAttributes = '';
            },            
        },
        mounted(){
       		this.getAllReports();
        }
    }
</script>

<style scoped>

.ReReportForm >>> .el-select .el-input input {height: 41px;}

</style>
